import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "./servicessection.css";
import AnimatedCanvas from "../../AnimatedCanvas";

// 1. Import your exact background video file here
// import bgVideo from "../../assets/bg-animation.mp4"; 

import img1 from "../../assets/testingimages/designwhychoose/icon1.png";
import img3 from "../../assets/testingimages/designwhychoose/icon3.png";
import img6 from "../../assets/testingimages/designwhychoose/icon6.png";
import img5 from "../../assets/testingimages/designwhychoose/icon4.png";
import img4 from "../../assets/testingimages/designwhychoose/icon5.png";
import img2 from "../../assets/testingimages/designwhychoose/icon2.png";
import Popupboxx from "../Popupbox/Popupbox";

function ServicesSection() {
  const [isMobile, setIsMobile] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  const designData = [
    {
      image: img1,
      title: "Hands-on DevOps Training",
      desc:
        "Gain real-world experience with DevOps tools like Git, Docker, Kubernetes, Jenkins, and CI/CD pipelines through live projects.",
    },
    {
      image: img2,
      title: "Master CI/CD & Cloud Deployment",
      desc:
        "Learn continuous integration, continuous delivery, infrastructure automation, and cloud deployment strategies.",
    },
    {
      image: img3,
      title: "Expert-Led Sessions",
      desc:
        "Learn directly from experienced DevOps engineers with 10+ years of real-time industry and production experience.",
    },
    {
      image: img4,
      title: "Career-Focused Curriculum",
      desc:
        "Our DevOps program is designed to help you become a DevOps Engineer with strong automation and cloud skills.",
    },
    {
      image: img5,
      title: "Industry-Recognized Certification",
      desc:
        "Earn a professional certification that validates your DevOps expertise and improves your job opportunities.",
    },
    {
      image: img6,
      title: "Job Placement Support",
      desc:
        "Get resume building, mock interviews, and placement assistance with top IT companies and startups.",
    },
  ];

  return (
    <>

      <section className="services-section">
        <div className="container">
          <section className="section-margin">
            <div className="headlines-for-all">
              <h4 data-aos="fade-up">
                <span>Why Choose </span> DevOps Course?
              </h4>
              <p className="service-section-para" data-aos="fade-up">
                Choosing us means leveraging our 10 years of expertise in DevOps. We specialize in automating workflows, enhancing collaboration, and optimizing software delivery pipelines using the latest DevOps tools and methodologies. Our program ensures you master industry best practices, equipping you to excel in DevOps and drive seamless development and operations.            </p>
            </div>
          </section>

          {/* Mobile Swiper Layout */}
          {isMobile ? (
            <div className="services-swiper">
              <Swiper
                modules={[Autoplay, Pagination]}
                spaceBetween={20}
                slidesPerView={1}
                autoplay={{ delay: 2500, disableOnInteraction: false }}
                pagination={{ clickable: true }}
                loop={true}
              >
                {designData.map((service, index) => (
                  <SwiperSlide key={index}>
                    <div className="service-card" data-aos="fade-up" data-aos-delay={index * 150}>
                      {/* <VideoBackground /> */}
                      <AnimatedCanvas />

                      <div className="service-card-content">
                        <div className="service-icon">
                          <img src={service.image} className="image-section" alt={service.title} width={90} height={90} />
                        </div>
                        <h3 className="service-title">{service.title}</h3>
                        <p className="service-description">{service.desc}</p>
                        <button className="card-button" onClick={() => setIsPopupOpen(true)}>More info</button>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          ) : (
            /* Desktop Grid Layout */
            <div className="services-grid">
              {designData.map((service, index) => (
                <div className="service-card" key={index} data-aos="fade-up" data-aos-delay={index * 150}>
                  {/* <VideoBackground /> */}
                  <AnimatedCanvas />

                  <div className="service-card-content">
                    <div className="service-icon">
                      <img src={service.image} className="image-section" alt={service.title} />
                    </div>
                    <h3 className="service-title">{service.title}</h3>
                    <p className="service-description">{service.desc}</p>
                    <button className="card-button" onClick={() => setIsPopupOpen(true)}>More info</button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      <Popupboxx isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} />
    </>
  );
}

export default ServicesSection;